/**
 * Adds the "No Selection" button behaviour used to skip setting materials
 * on faceplates and art layers.
 */
export class NoSelectionComponent {
  constructor(parent) {
    this.parent = parent;
  }

  async loadState() {

    // make sure to select clear option visually
    for (let choice of Object.values(this.parent.controller.state.choices)) {
      if (choice.categoryId === this.parent.id && choice.name == '-clear-option-') {
        const $btn = this.parent.$container.find('.swatch-group-btn[data-name="-clear-option-"]');
        $btn.addClass('active');
        $btn.siblings().removeClass('active');

        this.parent.$container.find('.title .icon').css("background-image", "");
        this.parent.$container.find('.label').text(`: No Selection`);
        this.parent.$container.addClass('has-selection');
        // disable default swatch group options on clear option
        this.parent.$container.find('.swatch-group').removeClass('active');

        const $uploadUIGroup = this.parent.$container.find('.swatch-group[data-name=upload]');
        if ($uploadUIGroup && $uploadUIGroup.length > 0) {
          $uploadUIGroup.addClass('active');
          $uploadUIGroup.siblings().removeClass('active');
        }
      }
    }
  }

  async activateSwatchGroup($swatchGroup) {
    const name = $swatchGroup.attr('data-name');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');
    const $price = this.parent.$container.find('.price');

    if (name === '-clear-option-') {
      await this.parent.controller.updateMaterial({
        base_color: '#fff'
      }, side, layer);

      this.parent.$container.trigger('swatch-selected', {
        id: this.parent.id,
        layer,
        side,
        name,
        group: { name: "Art", group_type: "Art", group_label: "Art" }
      });

      // find color swatches and remove them
      if (this.parent.$container.attr('data-type') == 'color-parent') {
        const $next = this.parent.$container.next();
        $next.find('.swatch').removeClass('active');
        // reset color-child swatch selections and category UI state.
        $next.removeClass('enabled');
        $next.removeClass('has-selection');
        $next.removeClass('collapsed');
        $next.hide();
        delete this.parent.controller.state.choices[this.parent.$container.attr('id') + '-colors'];
      }

      this.parent.$container.find('.swatch').remove('active');

      // move onto next category if not enabled
      this.parent.controller._moveNextCategory(this.parent.$container, "no-select");

      this.parent.$container.find('.title .icon').css("background-image", "");
      this.parent.$container.find('.label').text(`: No Selection`);

      // mark this category as having selection. Used to disable auto move
      // to next category when previous one's selection changes.
      this.parent.$container.addClass('has-selection');
      this.parent.controller.validate();
      $price.text('');
    }
  }
}